import React from 'react';
import './ForgotPassword.css';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import FontIcon from '../../components/fontIcon/FontIcon';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';
import Label from '../../components/label/Label';

export default class ForgotPassword extends FormTemplate {
	sendResetEmail = async () => {
		let value = this.getValue();
		// eslint-disable-next-line no-undef
		if (value?.email?.indexOf('@') === -1) {
			return toasts.show('Enter a valid email');
		}
		await mainAPI.user.forgot_password({ email: value.email.trim() });
		toasts.show('Check your email', 10000);
		this.props.close();
	};

	render() {
		return (
			<div className="forgot-password-card">
				<FontIcon name="icon-close" onClick={this.props.close}>
					<div tabIndex="0"/>
				</FontIcon> 
				<Label black className="enter-email">
					Enter Your Email
				</Label>
				<Input
					ref={(ref) => (this.myRefs.email = ref)}
					center
					placeholder="Email address"
					value={this.props.attemptedEmail}
				/>
				<Button center color="white" bg="blue" onClick={this.sendResetEmail}>
					Send Reset Email
				</Button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/cards/forgotPassword/ForgotPassword.jsx